import styled from 'styled-components';
import { SIZE, FONTS, COLORS } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const Wrapper = styled.div`
  max-width: 280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    max-width: 480px;
  }
`;

export const Order = styled.span`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 10px;
  color: ${COLORS.GRAY_DARK};
  display: block;
`;

export const Message = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  color: ${COLORS.BLACK};
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const Description = styled.ol`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 14px;
  color: ${COLORS.BLACK};
  margin: 15px 0 0;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const Detail = styled.li``;

export const ButtonWrapper = styled(Button)`
  margin-top: 20px;
`;

export const ButtonExit = styled(Button)`
  margin-top: 10px;
`;
